webpackJsonp([35783957827783],{

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg.1a06e2df.jpg";

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg2.fc242759.jpg";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  width: 250px;\n  height: 400px;\n  background-color: rgba(0, 0, 0, .7);\n  border: 1px solid dimgrey;\n  grid-column-start: 3;\n  grid-row-start: 2;\n  grid-row-end: 3;\n  justify-self: center;\n\n  @media (max-width: 850px) {\n    grid-column-start: 2;\n  }\n'], ['\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  width: 250px;\n  height: 400px;\n  background-color: rgba(0, 0, 0, .7);\n  border: 1px solid dimgrey;\n  grid-column-start: 3;\n  grid-row-start: 2;\n  grid-row-end: 3;\n  justify-self: center;\n\n  @media (max-width: 850px) {\n    grid-column-start: 2;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: white;\n  font-size: 20px;\n  text-decoration: none;\n  line-height: 200%;\n\n  &:hover {\n    color: grey;\n  }\n'], ['\n  color: white;\n  font-size: 20px;\n  text-decoration: none;\n  line-height: 200%;\n\n  &:hover {\n    color: grey;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 200px;\n  border-bottom: 1px solid dimgrey;\n  text-align: center;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 30px;\n'], ['\n  width: 200px;\n  border-bottom: 1px solid dimgrey;\n  text-align: center;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 30px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  height: 100vh;\n  display: grid;\n  grid-template-columns: 1fr 3fr 1fr 20px;\n  grid-templete-rows: 1fr 3fr 1fr;\n\n  @media (max-width: 850px) {\n    background: url(', ') no-repeat center;\n    grid-template-columns: 1fr 3fr 1fr;\n  }\n'], ['\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  height: 100vh;\n  display: grid;\n  grid-template-columns: 1fr 3fr 1fr 20px;\n  grid-templete-rows: 1fr 3fr 1fr;\n\n  @media (max-width: 850px) {\n    background: url(', ') no-repeat center;\n    grid-template-columns: 1fr 3fr 1fr;\n  }\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(144);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(24);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.div(_templateObject);
	
	var L = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2);
	
	var GalleryList = _styledComponents2.default.div(_templateObject3);
	
	var NavList = function NavList() {
	  return _react2.default.createElement(
	    List,
	    null,
	    _react2.default.createElement(
	      GalleryList,
	      null,
	      _react2.default.createElement(
	        L,
	        { to: '/Family-run' },
	        'Family Run'
	      ),
	      _react2.default.createElement(
	        L,
	        { to: '/DownState' },
	        'Downstate'
	      ),
	      _react2.default.createElement(
	        L,
	        { to: '/Chicago7879' },
	        'Chicago 78/79'
	      ),
	      _react2.default.createElement(
	        L,
	        { to: '/CruiseControl' },
	        'Cruise Control'
	      )
	    ),
	    _react2.default.createElement(
	      L,
	      { to: '/About' },
	      'About'
	    )
	  );
	};
	
	var BG = _styledComponents2.default.div(_templateObject4, __webpack_require__(537), __webpack_require__(538));
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    BG,
	    null,
	    _react2.default.createElement(NavList, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a4604d820fb090fbfecf.js